var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M12 6a6 6 0 10-6.938 5.927V7.734H3.54V6h1.523V4.678c0-1.504.896-2.334 2.267-2.334.656 0 1.343.117 1.343.117v1.477h-.757c-.745 0-.978.462-.978.936V6h1.665l-.266 1.734h-1.4v4.193A6.001 6.001 0 0012 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M8.336 7.734L8.602 6H6.937V4.874c0-.474.233-.936.978-.936h.757V2.46s-.687-.117-1.343-.117c-1.37 0-2.266.83-2.266 2.334V6H3.538v1.734h1.523v4.193a6.045 6.045 0 001.875 0V7.734h1.399"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default ForwardRef;